// extracted by mini-css-extract-plugin
module.exports = {"container":"tooManyAppointments_container__3VOFo","button":"tooManyAppointments_button__JAnrN button_button__2n_ir"};